export const team = [
  {
    id: "pm",
    name: "Interested? mail CV at projectmanager@projectdestination.se",
    role: "Project Manager",
    linkedin: "https://www.linkedin.com/company/project-destination",
    mail: "Apply for 24/25 team!",
    image: "placeholder.png",
  },
  {
    id: "vpm",
    name: "Interested? mail CV at projectmanager@projectdestination.se",
    role: "Vice Project Manager, <br /> Treasurer",
    linkedin: "https://www.linkedin.com/company/project-destination",
    mail: "Apply for 24/25 team!",
    image: "placeholder.png",
  },
  {
    id: "irm",
    name: "Interested? mail CV at projectmanager@projectdestination.se",
    role: "International Relations Manager",
    linkedin: "https://www.linkedin.com/company/project-destination",
    mail: "Apply for 24/25 team!",
    image: "placeholder.png",
  },
  {
    id: "pm",
    name: "Interested? mail CV at projectmanager@projectdestination.se",
    role: "Project Manager",
    linkedin: "https://www.linkedin.com/company/project-destination",
    mail: "Apply for 24/25 team!",
    image: "placeholder.png",
  },
  {
    id: "em",
    name: "Interested? mail CV at projectmanager@projectdestination.se",
    role: "Event Manager",
    linkedin: "https://www.linkedin.com/company/project-destination",
    mail: "Apply for 24/25 team!",
    image: "placeholder.png",
  },
  {
    id: "mm",
    name: "Interested? mail CV at projectmanager@projectdestination.se",
    role: "Marketing Manager",
    linkedin: "https://www.linkedin.com/company/project-destination",
    mail: "Apply for 24/25 team!",
    image: "placeholder.png",
  },
  {
    id: "ad",
    name: "Interested? mail CV at projectmanager@projectdestination.se",
    role: "Art Director",
    linkedin: "https://www.linkedin.com/company/project-destination",
    mail: "Apply for 24/25 team!",
    image: "placeholder.png",
  },
  {
    id: "itm",
    name: "Interested? mail CV at projectmanager@projectdestination.se",
    role: "IT Manager",
    linkedin: "https://www.linkedin.com/in/kevin-tony/",
    mail: "Apply for 24/25 team!",
    image: "placeholder.png",
  },
];
